import { render } from "./ListaTareas.vue?vue&type=template&id=574cc0a8"
import script from "./ListaTareas.vue?vue&type=script&lang=js"
export * from "./ListaTareas.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__